import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=35ea7cd1&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=35ea7cd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ea7cd1"]])

export default __exports__